module.exports = __webpack_public_path__ + "media/integrations/etsy-21ee9d15.svg";